<vx-dialog size="sm">
  <vx-dialog-header
    icon="shield-check"
    [title]="'components.reauthenticateDialog.title' | transloco"
    [description]="
      (step() === 'password'
        ? 'components.reauthenticateDialog.passwordDescription'
        : step() === 'failed'
          ? 'components.reauthenticateDialog.failedDescription'
          : step() === 'aal2'
            ? 'components.reauthenticateDialog.secondFactorDescription'
            : step() === 'code'
              ? 'components.reauthenticateDialog.codeSent'
              : 'components.reauthenticateDialog.codeDescription'
      ) | transloco: { email: email() }
    "
    [closeLabel]="'components.dialog.closeBtn' | transloco"
    (closeRequested)="close()" />

  @switch (step()) {
    @case ('aal2') {
      <app-kratos-form-v2
        appearance="vx"
        [flow]="loginFlow()"
        [groups]="['totp', 'webauthn']"
        (submitFlow)="submitSecondFactor($event)" />
    }

    @case ('password') {
      <form
        class="flex flex-col gap-3"
        [formGroup]="passwordForm"
        (ngSubmit)="submitPassword()"
        novalidate>
        <!-- lets a password manager offer this account's password -->
        <input
          type="email"
          name="username"
          autocomplete="username"
          class="hidden"
          [value]="email()"
          readonly
          aria-hidden="true"
          tabindex="-1" />
        <vx-form-field
          [label]="'components.reauthenticateDialog.passwordLabel' | transloco">
          <vx-input
            type="password"
            name="password"
            formControlName="password"
            autocomplete="current-password"
            (keydown.enter)="submitPassword()" />
        </vx-form-field>
        @if (messages().length) {
          <app-kratos-messages [messages]="messages()" />
        }
        @if (offersCode()) {
          <button
            type="button"
            class="self-start text-13 tracking-tight text-zinc-400 underline underline-offset-2 hover:text-zinc-200"
            (click)="useCode()">
            {{ 'components.reauthenticateDialog.useCode' | transloco }}
          </button>
        }
      </form>
    }

    @case ('send-code') {
      @if (messages().length) {
        <app-kratos-messages [messages]="messages()" />
      }
      @if (hasPassword()) {
        <button
          type="button"
          class="self-start text-13 tracking-tight text-zinc-400 underline underline-offset-2 hover:text-zinc-200"
          (click)="usePassword()">
          {{ 'components.reauthenticateDialog.usePassword' | transloco }}
        </button>
      }
    }

    @case ('code') {
      <div class="flex flex-col items-center gap-3 py-2">
        <app-code-entry
          [step]="codeEntry"
          [messages]="messages()"
          (completed)="submitCode($event)" />
        <button
          type="button"
          class="text-13 tracking-tight text-zinc-400 underline underline-offset-2 hover:text-zinc-200"
          [disabled]="codeEntry.busy()"
          (click)="sendCode()">
          {{ 'components.reauthenticateDialog.resendCode' | transloco }}
        </button>
      </div>
    }

    @case ('failed') {}

    @default {
      <div class="flex flex-col gap-3">
        <vx-skeleton class="h-9 w-full" />
        <vx-skeleton class="h-9 w-full" />
      </div>
    }
  }

  @if (step() === 'failed') {
    <vx-dialog-footer>
      <vx-button variant="outline" tone="secondary" (click)="close()">
        {{ 'components.dialog.cancelBtn' | transloco }}
      </vx-button>
      <vx-button (click)="start()">
        {{ 'components.reauthenticateDialog.retryBtn' | transloco }}
      </vx-button>
    </vx-dialog-footer>
  }

  @if (step() === 'password' || step() === 'send-code') {
    <vx-dialog-footer>
      <vx-button variant="outline" tone="secondary" (click)="close()">
        {{ 'components.dialog.cancelBtn' | transloco }}
      </vx-button>
      @if (step() === 'password') {
        <vx-button [loading]="codeEntry.busy()" (click)="submitPassword()">
          {{ 'components.reauthenticateDialog.confirmBtn' | transloco }}
        </vx-button>
      } @else {
        <vx-button [loading]="codeEntry.busy()" (click)="sendCode()">
          {{ 'components.reauthenticateDialog.sendCodeBtn' | transloco }}
        </vx-button>
      }
    </vx-dialog-footer>
  }
</vx-dialog>
